module.exports = (__webpack_require__(0))(110);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/ItemListWidget.js from dll-reference girder_lib
// module id = 119
// module chunks = 0